<template lang="pug">
div(fluid).candidate.pt-8
  .text-center.pa-10(v-if="loading" data-test="candidate-loading")
      v-progress-circular(indeterminate size=64 color="warning")
  v-container(fluid).candidate__wrapper
    .candidate__main(v-if="!loading && model" data-test="candidate-item")
      v-form(ref="form")
        fields(:model="model" 
          :formErrors="formErrors" 
          ref="fields"
          :goBack="goBack"
          @checkReservationClicked="checkReservationQueue"
          @reservedExam:update="resetReservations"
          @candidateNumberChanged="markCandidateNumberAsChanged"
          @labelsChanged="assignLabels"
          @parseReserveNumber="parseReserveNumber"
        )
        reservations(
          v-if="model.filteredRequests"
          :model="model" 
          ref="reservations" 
          :formErrors="formErrors" 
          @remove="removeReservationRequest"
          @orderingChanged="saveRequestsAfterDragging" 
          :getExamLocation="getExamLocation"
          :getCourseLocation="getCourseLocation"
        ).item-container
        
    .candidate__additional(v-if="!loading && model")
      div.candidate__additional-wrapper
        send-log-field( :ID="ID" v-if="logs")
        logs(:value="logsShowing" v-if="logs" @click:loadMore="loadLogsMore" :model="logs" ref="log")
          template(v-slot:header="props")
            logsTabs(:model="props.model" :loadData="props.loadData" :getDefaultPaginationParams="props.getDefaultPaginationParams")
          template(v-slot:candidateName="{candidate, fullName}")
            span.link  {{ fullName }}
            span.link  - {{ candidate.number }}
        candidate-courses-history(:courses="model.exam_request_history" @makeActive="addFilledReservations")
      
  .candidate__actions
    div(
      
    ).candidate__actions-wrapper.d-flex
      similar(:ID="model.ID" :candidateNumber="model.candidateNumber" v-if="model").ml-4
      v-spacer
      v-btn(@click="goBackHandler" outlined color="primary" data-test='candidate_cancel').mr-4 cancel
      //- v-btn(color='primary' @click="update") Save
      update-action(
        :model="model" 
        :formErrors="formErrors" 
        :updateRequests="updateRequests"
        :candidateNumberChanged="candidateNumberChanged" 
        @submit="update"
      )

  confirmation-dialog(
    v-model="leaveModalShowing"
    @okBtnClicked="goBackAccept"
    width="420px"
    title='You have unsaved candidate data'
    descr='Are you sure you want to close the candidate? All data that you did not save will be lost.'
  )

</template>

<script>
import {mapGetters, mapActions} from "vuex"

import Svc from "../../core/candidates-service"
import Model from "../../core/candidates-reservation-model"
import FormErrors from "@/util/form-errors"
import ErrMixin from "@/mixins/errors.mixin"
import {showSnackbar} from "@/util"
import {LOG_PAGE, DRAWER_WIDTH} from "@/util/const"
import CandidateLogModel from "../../core/models/candidatesLogModel"

import Logs from "@/app/admin/components/Log.vue"
import Tabs from "../../components/CandidateItemTab.vue"
import Fields from "../../components/CandidateItemFields.vue" 
import { API_ATTRIBUTES, API_ATTRIBUTES_NESTED } from '../../core/candidates-const'

export default {
  name: 'CandidatesItemPage',
  mixins: [ErrMixin],

  props: {
    query: Object,
    ID: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    svc: null,
    model: null,
    loading: true,
    formErrors: null,
    reservationTab: null,
    logs: null,
    logsShowing: false,
    editing: false,
    leaveModalShowing: false,
    closeCallback: null,
    candidateNumberChanged: false
  }),


  computed:{ 
    ...mapGetters({
      drawerStatus: 'crmDrawer/value',
      currentUser: 'user/current'
    }),

    actionPanelMarginRight() {
      if(!this.drawerStatus) return '25px'
      return (DRAWER_WIDTH + 25) + 'px'
    }
  },

  created() {
    this.init()
  },

  async mounted() {
    await this.loadData()
    this.loadAdditionalData()
    this.processAfterDataLoading()
    this.addHotkeyToSave()
    this.loadLogs()
  },

  methods: {
    ...mapActions({
      getExamLocation: 'crmExamLocation/list',
      getCourseLocation: 'crmCourseCities/list'
    }),

    addFilledReservations(reservations) {
      this.model.addFilledReservationRequests(reservations)
      this.$refs.reservations.setRequests()
    },

    init() {
      this.svc = new Svc()
      this.formErrors = new FormErrors()
      this.initLogs(this.currentUser.logsWebsocketPath)

    },

    async parseReserveNumber(id) {
      await this.svc.parseReservationNumber(id)
    },

    async initLogs(wsURL) {
      let tokens = await this.$auth.getTokensFromRepoOrRefresh()
      this.logs = new CandidateLogModel(
        {candidate: this.ID, page: [LOG_PAGE.CONTANCT]}, 
        `${wsURL}?auth_token=${tokens.access}`
      )
      this.logs.ws.addEventListener("message", this.addToCandidate)
      this.logsShowing = true
    },

    addToCandidate(msg) {
      this.logs.addToCandidate(msg, this.onLogUpdate)
      
    },

    async loadData() {
      try {
        this.loading = true
        let res = await this.svc.find(this.ID)
        this.model = new Model(res)
        this.loading = false
      } catch (error) {
        console.log(error)
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    loadAdditionalData() {
      this.getExamLocation({cache: true})
    },

    processAfterDataLoading() {
      this.$refs.fields.disabled.checkCBRStatus(this.model.status) 
    },

    async update() {
      console.log(this.model,this.model.exercises_access_expires_at, 'model')
      try {
        this.updating = true
        this.updateRequests()
        let res = await this.svc.put(this.ID, this.model)
        this.model.editing = false
        this.model.merge(new Model(res))
        //         Todo need global refactor
        setTimeout(() => {
          this.setReservationsRequest()
        }, 0)
        this.updating = false
        this.$notify({text: 'Updated', type: 'success'})
        this.$emit('saved', this.model)
      } catch (error) {
        console.log(error)
        this.updating = false
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE,
          formErrors: this.formErrors, 
          apiAttributes: API_ATTRIBUTES,
          nestedErrors: API_ATTRIBUTES_NESTED,
          showErrorModal: true })
        this.handlingErrorWithOldDates(this.formErrors)
      }
    },

    

    updateRequests() {
      this.model.requests = this.$refs.reservations.requests
    },
    
    handlingErrorWithOldDates(formErrors) {
      if('courseDate' in formErrors.fields) {
        formErrors.fields.courseDate = 'Please select a course'
      }
      if(!('requests' in formErrors.fields)) return
      formErrors.fields.requests.forEach(field => {
        if(!(('courseDate') in field)) return
        field.courseDate = 'Please select a course'
      })
    },

    async saveRequestsAfterDragging() {
      try {
        let res = await this.svc.updateReservations(
          this.ID, 
          this.model._getRequestsApiDataBy(this.$refs.reservations.requests)
        )
        this.$notify({text: 'Ordering changed', type: 'success' })
      } catch (error) {
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE,
          formErrors: this.formErrors, 
          apiAttributes: API_ATTRIBUTES,
          nestedErrors: API_ATTRIBUTES_NESTED })
      }
    },

    async checkReservationQueue() {
      try {
        let res = await this.svc.checkReservationQueueBulk([this.ID])
        this.model.failed = false
        this.$notify({text: 'Try to reserve', type: 'success' })
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    addReservationRequest() {
      this.model.addReservationRequest()
    },

    removeReservationRequest(index) {
      this.model.removeReservationRequest(index)
    },

    goBackHandler(closeCallback) {
      if(closeCallback) this.closeCallback = closeCallback
      if(this.model.editing) {
        this.leaveModalShowing = true
        return
      }
      this.goBack()
    },

    goBack() {
      this.model.editing = false
      this.$emit('close', this.ID)
    },

    goBackAccept() {
      this.goBack()
      if(this.closeCallback) this.closeCallback()
    },

    loadLogs() {
      this.$refs.log.loadData({
        ...this.$refs.log.getDefaultPaginationParams()
      })
    },

    loadLogsMore() {
      this.$refs.log.loadMore({
      })
    },

    addHotkeyToSave() {
      document.addEventListener('keyup', this.saveOnHotkey, false);
    },

    saveOnHotkey(e) {
      e.preventDefault()
      if (e.ctrlKey && e.shiftKey && e.keyCode == 83) {
        this.update()
      }
    },
    
    onLogUpdate(msg) {
      this.$notify({text: msg.comment, type: msg.status, title: msg.candidate.name })
    },

    startEditing() {
      this.editing = true
    },

    setReservationsRequest() {
      this.$refs.reservations.addRequestIfNoAvailable()
    },

    resetReservations() {
      this.$refs.reservations.resetRequests()
    },

    async markAsProcessed(items) {
      try {
        let ids = [this.model.ID]
        await this.svc.markAsProcessed(ids)
        this.$notify({text: 'Mark as processed', type: 'success'})
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
        return Promise.reject(error)
      }
    },

    markCandidateNumberAsChanged() {
      this.candidateNumberChanged = true
    },

    async assignLabels(labels) {
      this.model.labels = labels
      // this.update()
      try {
        
        this.model.labels = labels
        await this.svc.updateLabels(this.ID, this.model.labels)
        this.$notify({text: 'Labels assigned', type: 'success'})
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
        return Promise.reject(error)
      }
    },

  },

  beforeDestroy() {
    this.logs.ws.removeEventListener("message", this.addToCandidate)
    this.logs.ws.close()

  },

  provide: function() {
    return {
      svc: () => this.svc,
      startEditing: this.startEditing,
      markAsProcessed: this.markAsProcessed
    }
  },

  components: {
    courseLocationFilter: () => import ('@/app/admin/components/FilterCourseLocaiton.vue'),
    reservations: () => import('./CanditeReservations.vue'),
    fields: Fields,
    tabs: Tabs,
    logs: Logs,
    confirmationDialog: () => import('@/components/global/ConfirmationDialog.vue'),
    updateAction: () => import('./CandidateItemUpdate.vue'),
    similar: () => import('./CandidateSimilar.vue'),
    logsTabs: () => import('./CandidateLogTab.vue'),
    sendLogField: () => import('./CandidateSendLogField.vue'),
    CandidateCoursesHistory: () => import('./CandidateCoursesHistory.vue'),
  }
}
</script>

<style lang="scss" scoped>
.candidate {
  
  &__main {
    // width: 60%;
    min-width: 916px;
  }
  &__additional {
    width: 100%;
    &-wrapper {
      width: 400px;
    }
  }
  &__actions {
    width: 100%;
    border-top: 1px solid $border-color;
    position: fixed;
    bottom: 0px;
    left: 0;
    right: 0;
    z-index: 10;
    &-wrapper {
      background: #fff;
      padding: 20px 0;
      padding-right: 12px;
      
    }
  }
  &__wrapper {
    display: flex;
  }
}

.log-btn {
  position: absolute;
  right: 20px;
  top: -70px;
}
</style>
